import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

export const Teacher = () => (
    <section id="teacher" className="scroll-mt-24 border-y border-ground-line/60 bg-ground" data-testid="teacher-section">
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 py-20 lg:grid-cols-12 lg:py-28">
            <motion.div
                className="relative lg:col-span-5"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <div className="absolute -inset-3 rounded-[2rem] border-2 border-sun/30" />
                <img
                    src="/assets/teacher.jpg"
                    alt="YNova Education English teacher, pictured in a navy blazer"
                    data-testid="teacher-portrait-image"
                    className="relative aspect-[4/5] w-full rounded-[2rem] object-cover shadow-2xl shadow-black/40"
                    loading="lazy"
                />
            </motion.div>
            <motion.div
                className="lg:col-span-7"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
            >
                <p className="text-xs font-bold tracking-widest text-sun uppercase">Meet your teacher</p>
                <h2 className="font-heading mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                    A welcoming space to learn and grow.
                </h2>
                <p className="mt-5 text-base text-mist sm:text-lg">
                    At YNova Education, our aim is to help young learners build stronger English skills in a
                    supportive, encouraging online environment.
                </p>
                <p className="mt-4 text-base text-mist sm:text-lg">
                    Lessons are planned around each learner’s grade, goals and areas for growth, with practice in
                    reading, comprehension, grammar, spelling and writing.
                </p>
                <p className="mt-4 text-base text-mist sm:text-lg">
                    Parents are welcome to book a free introductory consultation to discuss their child’s learning
                    needs and ask questions before getting started.
                </p>
                <Button asChild size="lg" className="mt-8 rounded-full px-7 font-bold shadow-xl shadow-sun/25 transition-transform duration-200 hover:scale-105">
                    <a href="#contact" data-testid="teacher-meet-btn">
                        Meet with YNova Education
                        <ArrowRight className="ml-2 h-5 w-5" />
                    </a>
                </Button>
            </motion.div>
        </div>
    </section>
);
